import ProfileApp from "./components/profile.jsx";

const App = () => {
    return (
        <ProfileApp />
    );
};
  export default App;